import {
    API_BASE
} from "../../config";


const getSessionValue = (key) => {
    const value =
        sessionStorage.getItem(key);

    if (value === null) {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};


const getAuthHeaders = () => {

    const token =
        getSessionValue("token");

    const idUser =
        getSessionValue("id_user");

    return {
        "Content-Type": "application/json",
        "x-access-token": token,
        "x-access-id_user": String(idUser)
    };
};


export const getAdminUserDetails = async (
    userId
) => {

    const response = await fetch(
        `${API_BASE}/admin/users/${userId}`,
        {
            method: "GET",
            headers: getAuthHeaders()
        }
    );

    const data = await response.json();

    if (
        !response.ok ||
        data.message !== "DATA_SUCCESS"
    ) {
        throw new Error(
            data.message ||
            "ADMIN_USER_DETAILS_ERROR"
        );
    }

    return data;
};


export const verifyAdminUser = async (userId) => {
    const response = await fetch(
        `${API_BASE}/admin/users/${userId}/verify`,
        {
            method: "PATCH",
            headers: getAuthHeaders()
        }
    );

    const data = await response.json();

    if (
        !response.ok ||
        data.message !== "USER_VERIFIED"
    ) {
        throw new Error(
            data.message || "ADMIN_VERIFY_USER_ERROR"
        );
    }

    return data;
};


export const rejectAdminUser = async (
    userId,
    reason
) => {
    const response = await fetch(
        `${API_BASE}/admin/users/${userId}/reject`,
        {
            method: "PATCH",
            headers: getAuthHeaders(),
            body: JSON.stringify({
                reason: reason || null
            })
        }
    );

    const data = await response.json();

    if (
        !response.ok ||
        data.message !== "USER_REJECTED_AND_DELETED"
    ) {
        throw new Error(
            data.message || "ADMIN_REJECT_USER_ERROR"
        );
    }

    return data;
};

export const deleteAdminUser = async (userId) => {
    const response = await fetch(
        `${API_BASE}/admin/users/${userId}`,
        {
            method: "DELETE",
            headers: getAuthHeaders()
        }
    );

    const data = await response.json();

    if (
        !response.ok ||
        data.message !== "USER_DELETED"
    ) {
        throw new Error(
            data.message || "ADMIN_DELETE_USER_ERROR"
        );
    }

    return data;
};




export const getAdminUsers = async () => {

    const response = await fetch(
        `${API_BASE}/admin/users`,
        {
            method: "GET",
            headers: getAuthHeaders()
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new Error(
            data.message ||
            "ADMIN_USERS_ERROR"
        );
    }

    return data;
};
